/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";
import { observer, inject } from "mobx-react";
// UI Frameworks
import { Typography, Icon } from "antd";
import { FormComponentProps } from "antd/lib/form";
// Hooks and utilities
import UserStore from "state/user";
// styles
import styles from "./index.module.scss";

const { Text, Title } = Typography;

interface IProps extends FormComponentProps {
	user: UserStore;
}

const FirstStep: React.FC<IProps> = (props: IProps) => {
	return (
		<div className="container">
			<div className={styles["financial"]}>
				<Title level={4}>
					<Icon type="gold" /> دریافت طلای فیزیکی
				</Title>
				<Text>{props.user.baazarConfigs.BAAZAR_TO_GOLD_MESSAGE}</Text>
			</div>
		</div>
	);
};

export default inject("user")(observer(FirstStep));
